module.exports = __webpack_public_path__ + "img/1.516c4cfa.png";